export enum SiteType {
  AWC = 1,
  VK_MINIGAME = 2,
  YUVI = 6,
  MINIGAME = 7
}

interface CasinoSiteTypeInfo {
  value: SiteType
  name: string
}

const casinoSiteTypeConst: Record<keyof typeof SiteType, CasinoSiteTypeInfo> = Object.freeze({
  AWC: {
    value: SiteType.AWC,
    name: "AWC"
  },
  YUVI: {
    value: SiteType.YUVI,
    name: "YUVI"
  },
  MINIGAME: {
    value: SiteType.MINIGAME,
    name: "MINIGAME"
  },
  VK_MINIGAME: {
    value: SiteType.VK_MINIGAME,
    name: "VK_MINIGAME"
  }
})

export default casinoSiteTypeConst
